// extracted by mini-css-extract-plugin
module.exports = {"container":"light_header-module--container--xU_6V","wrapper":"light_header-module--wrapper--nnE1x"};